import { TradingModule } from '../tradingModule/TradingModule';

type Props = {};

export const Main = (props: Props) => {
  return (
    <div
      style={{
        width: 'fit-content',
        height: 'fit-content',
      }}
    >
      <TradingModule />
    </div>
  );
};
